import Link from "next/link";

interface DialogueHeaderProps {
    context?: string
    title: string
    actionTitle?: string
    actionHref?: string
    onClose: () => void
    onAction?: () => void
}

export default function DialogueHeader(props: DialogueHeaderProps) {
    return (
        <div className="dialog-header">
            <div className="header-top">
                <span className="dialog-context">{props.context}</span>
                <div className="dialog-close" onClick={props.onClose}>
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="eoicn-close">
                        <path d="M19 19L5 5"></path>
                        <path d="M5 19L19 5"></path>
                    </svg>
                </div>
            </div>
            <div className="header-main">
                <h3 className="dialog-title">{props.title}</h3>
                {props.actionTitle && (
                    <>
                        {props.actionHref ? (
                            <Link className="header-action" href={props.actionHref}>
                                {props.actionTitle}
                            </Link>
                        ) : (
                            <Link className="header-action" href="#" onClick={props.onAction}>
                                {props.actionTitle}
                            </Link>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
